import { styled } from 'styled-components';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 541px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0px 0px 20px rgb(0 0 0 / 20%);
  box-sizing: border-box;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 16px;
  animation: fadeIn 0.2s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }

    to {
      opacity: 1;
      transform: translateY(0px);
    }
  }
`;

export default StyledContainer;